
import React, { useState, useEffect } from 'react';
import PageHeading from '../../components/PageHeading';
import { 
  SearchOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  AlipayOutlined, 
  ClockCircleOutlined,
  FileTextOutlined 
} from '@ant-design/icons';
import { debounce } from 'lodash';
import { Button, Input, message, Table, Tag, Popconfirm } from 'antd';
import axiosInstance from '../../utils/axios';
import { dateFormat } from '../../utils/dateFormats';
import { useNavigate } from 'react-router-dom';

const OldShows = () => {
  const navigate = useNavigate();
  const [shows, setShows] = useState({
		results: []
	});
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);

	useEffect(() => {
		const delayFetch = debounce(() => {
			fetchData();
		}, 550); // 550ms debounce

		delayFetch();
		
		return () => delayFetch.cancel();

		// eslint-disable-next-line
	}, [search, page]);

	const handleSearch = (e) => {
		setSearch(e.target.value);
		setPage(1);
	}
	
	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get(`show-management/shows/old/?page=${page}&search=${search}`);
			setShows(response.data);
		} catch (error) {
			message.error("Failed to fetch movie");
		} finally {
			setLoading(false);
		}
	};

	const cancel = () => message.info('Cancelled');

	const confirm = async (id) => {
		try {
			await axiosInstance.delete(`news_and_events/news/${id}/`);
			message.success("Deleted successfully");
			setPage(1);
			fetchData();
		} catch (err) {
			message.error("Cannot delete");
		}
	};

	const columns = [
		{
			title: 'Movie Name',
			dataIndex: 'movie_name',
			key: 'movie_name',
		},
		{
			title: 'Theatre Name',
			dataIndex: 'theatre_name',
			key: 'theatre_name',
		},
	  {
			title: 'Screen',
			dataIndex: 'screen_name',
			key: 'screen_name',
		},
    {
      title: 'Dates',
      dataIndex: 'dates',
      key: 'dates',
      render: (_, record) => {
        if (!record.dates || record.dates.length === 0) return null;
        const firstDate = record.dates[0].date;
        const lastDate = record.dates[record.dates.length - 1].date;

        return (
          <>
            <Tag color="green">{firstDate}</Tag> 
            {firstDate !== lastDate && <Tag color="blue">To {lastDate}</Tag>}
          </>
        );
      }
    },

		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => (
        <>
          <Button type="link" icon={<FileTextOutlined />} onClick={() => navigate(`/admin/shows/booking-summary/${record.id}`, { state: { showData: record } })} />
					<Popconfirm
						title="Delete"
						description="Are you sure to delete this item?"
						onConfirm={() => confirm(record.id)}
						onCancel={cancel}
						okText="Yes"
						cancelText="No"
					>
						<Button type="link" danger icon={<DeleteOutlined />} />
					</Popconfirm>
				</>
			)
		},
	];

  return(
  <div className="dashboard">
    <PageHeading name="Completed Shows" icon={<ClockCircleOutlined />} />
    <Input
				placeholder="Search here"
				prefix={<SearchOutlined />}
				style={{ width: "190px" }}
				onChange={(e) => handleSearch(e)}
		/>

    <Table
			dataSource={shows.results}
			loading={loading}
			columns={columns}
			rowKey="id"
      scroll={{ x: 'max-content' }}
      pagination={{
				current: page,
				pageSize: 20,
				total: shows.count,
				onChange: (newPage, _) => {
					setPage(newPage);
				}
			}}
		/>

  </div>
  );
}

export default OldShows;
